document.addEventListener('DOMContentLoaded', () => {
  const startOnFirstIntersect = ({
    items,
    first,
    addClass,
    step = 120,
    threshold = 0.2,
    root = null,
    rootMargin = '0px',
    beforeStart = null
  }) => {
    const list = Array.from(items || []);
    if (!list.length) return;

    const firstEl = first || list[0];

    const startAll = () => {
      if (typeof beforeStart === 'function') beforeStart();
      list.forEach((el, i) => {
        setTimeout(() => el.classList.add(addClass), i * step);
      });
    };

    if (!('IntersectionObserver' in window)) {
      startAll();
      return;
    }

    let triggered = false;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting || triggered) return;
        triggered = true;
        startAll();
        io.disconnect();
      });
    }, { root, threshold, rootMargin });

    io.observe(firstEl);
  };

  const collectionItems = document.querySelectorAll('.collection-list__item');
  if (collectionItems.length) {
    collectionItems.forEach((item, index) => {
      item.classList.add(index % 2 === 0 ? 'is-left' : 'is-right');
    });

    startOnFirstIntersect({
      items: collectionItems,
      addClass: 'is-visible',
      step: 200,
      threshold: 0.2
    });
  }

  const collapsible = document.querySelector('.collapsible-content');
  if (collapsible) {
    const accordions = collapsible.querySelectorAll('.accordion');
    startOnFirstIntersect({
      items: accordions,
      addClass: 'is-inview',
      step: 120,
      threshold: 0.15,
      rootMargin: '0px 0px -10% 0px'
    });
  }

  const sections = document.querySelectorAll('.shopify-section');
  sections.forEach(section => {
    const grid = section.querySelector('.product-grid');
    if (!grid) return;

    const firstItem = grid.querySelector('.grid__item');
    if (!firstItem) return;

    startOnFirstIntersect({
      items: [section],
      first: firstItem,
      addClass: 'is-anim-start',
      step: 0,
      threshold: 0.2
    });
  });

  const newsItems = document.querySelectorAll('.news-list-item');
  if (newsItems.length) {
    startOnFirstIntersect({
      items: newsItems,
      addClass: 'is-visible',
      step: 120,
      threshold: 0.2
    });
  }

});